import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { MultiSelect } from '@/components/forms/MultiSelect'
import { fetchUsers } from '@/reducers/organizations/organizationUsers.actions'
import { fetchOrganizationTags } from '@/reducers/organizations/organizationTags.actions'
import { NotificationSettings } from '@/components/notifications/NotificationSettings'

import './AdminNotificationSetupForm.scss'

// Admin-only flow (Image 3): pick recipients by user OR tag, then build
// the same filter + events_matrix the user-facing modal builds. On save
// the backend resolves tag_ids to user_ids, unions with the explicit
// user_ids, dedupes, and writes one subscription row per resulting
// target. Each target gets managed_by_admin=true so the "managed by
// your admin" indicator appears in their own modal until they edit it.
export const AdminNotificationSetupForm = ({ organizationId }) => {
  const dispatch = useDispatch()
  const orgUsers = useSelector((state) => state.organizationUsers?.users || [])
  const orgTags = useSelector((state) => state.organizationTags || [])

  const [targetUserIds, setTargetUserIds] = useState([])
  const [targetTagIds, setTargetTagIds] = useState([])

  useEffect(() => {
    if (organizationId && isEmpty(orgUsers)) {
      dispatch(fetchUsers({ organizationId }))
    }
    if (organizationId && isEmpty(orgTags)) {
      dispatch(fetchOrganizationTags({ organizationId }))
    }
  }, [organizationId])

  const userOptions = orgUsers.map((orgUser) => ({
    value: orgUser.id,
    label:
      orgUser.first_name || orgUser.last_name
        ? `${orgUser.first_name || ''} ${orgUser.last_name || ''}`.trim()
        : orgUser.username,
  }))
  const tagOptions = orgTags.map((tag) => ({ value: tag.id, label: tag.name }))

  const selectedUserValues = userOptions.filter((option) => targetUserIds.includes(option.value))
  const selectedTagValues = tagOptions.filter((option) => targetTagIds.includes(option.value))

  return (
    <div className="admin-notification-setup">
      <div className="admin-notification-setup__section">
        <h4 className="admin-notification-setup__heading">Assign notification to</h4>
        <MultiSelect
          options={userOptions}
          value={selectedUserValues}
          placeholder="Pick users…"
          onChange={(selected) => setTargetUserIds((selected || []).map((option) => option.value))}
          data-testid="admin-target-users-select"
        />
        <MultiSelect
          options={tagOptions}
          value={selectedTagValues}
          placeholder="Or pick by tag…"
          onChange={(selected) => setTargetTagIds((selected || []).map((option) => option.value))}
          data-testid="admin-target-tags-select"
        />
      </div>

      {/* Matrix + "Receive notifications from" filter render always so the
          admin can configure the settings before committing to recipients.
          The Save button inside NotificationSettings handles the empty-
          targets case (it requires at least one user or tag). */}
      <NotificationSettings adminTargetUserIds={targetUserIds} adminTargetTagIds={targetTagIds} />
    </div>
  )
}
